module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    staticClass: "address_settings interestsSettingsRoot",
    attrs: {
      "grid": true,
      "alignTop": true
    }
  }, [_c('Select', {
    staticClass: "column",
    attrs: {
      "label": "Интересующие проф,области",
      "name": "prof_spheres",
      "placeholder": "Выберите профессиональные области",
      "multiple": true,
      "filterable": true,
      "scroll": true,
      "error": _vm.errors.prof_spheres,
      "error-text": _vm.errors.prof_spheres,
      "options": _vm.profSpheresOptions
    },
    model: {
      value: (_vm.user.prof_spheres),
      callback: function($$v) {
        _vm.$set(_vm.user, "prof_spheres", $$v)
      },
      expression: "user.prof_spheres"
    }
  }), _c('Select', {
    staticClass: "column",
    attrs: {
      "label": "Интересующие компетенции",
      "name": "competences",
      "placeholder": "Выберите компетенции",
      "multiple": true,
      "filterable": true,
      "scroll": true,
      "error": _vm.errors.competences,
      "error-text": _vm.errors.competences,
      "options": _vm.competencesOptions
    },
    model: {
      value: (_vm.user.competences),
      callback: function($$v) {
        _vm.$set(_vm.user, "competences", $$v)
      },
      expression: "user.competences"
    }
  }), _c('Select', {
    staticClass: "column",
    attrs: {
      "label": "Интересующие профессии",
      "name": "professions",
      "placeholder": "Выберите профессии",
      "multiple": true,
      "filterable": true,
      "scroll": true,
      "error": _vm.errors.professions,
      "error-text": _vm.errors.professions,
      "options": _vm.professionsOptions
    },
    model: {
      value: (_vm.user.professions),
      callback: function($$v) {
        _vm.$set(_vm.user, "professions", $$v)
      },
      expression: "user.professions"
    }
  }), _c('p', {
    staticClass: "dedicatedBlockName"
  }, [_vm._v("ПОЖЕЛАНИЯ К ВАКАНСИИ")]), _c('div', {
    staticClass: "dedicatedBlockRoot"
  }, [_c('div', {
    staticClass: "dedicatedBlock dedicatedBlockFirst form form_grid form_top"
  }, [_c('FormInput', {
    staticClass: "column",
    attrs: {
      "label": "Должность",
      "name": "desired_position",
      "placeholder": "Должность",
      "maxlength": '9999999999',
      "error": _vm.errors.desired_position,
      "error-text": _vm.errors.desired_position
    },
    model: {
      value: (_vm.user.desired_position),
      callback: function($$v) {
        _vm.$set(_vm.user, "desired_position", $$v)
      },
      expression: "user.desired_position"
    }
  }), _c('Select', {
    staticClass: "column",
    attrs: {
      "label": "График работы",
      "name": "work_schedule_id",
      "placeholder": "Выберите график работы",
      "multiple": false,
      "filterable": false,
      "error": _vm.errors.work_schedule_id,
      "error-text": _vm.errors.work_schedule_id,
      "options": _vm.workScheduleDictionary
    },
    model: {
      value: (_vm.user.work_schedule_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "work_schedule_id", $$v)
      },
      expression: "user.work_schedule_id"
    }
  }), _c('Checkbox', {
    staticClass: "column",
    attrs: {
      "name": "is_ovz_adaptation",
      "error": _vm.errors.is_ovz_adaptation,
      "error-text": _vm.errors.is_ovz_adaptation
    },
    model: {
      value: (_vm.user.is_ovz_adaptation),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_ovz_adaptation", $$v)
      },
      expression: "user.is_ovz_adaptation"
    }
  }, [_vm._v("Требуется адаптация для ОВЗ")]), _c('Checkbox', {
    staticClass: "column",
    attrs: {
      "name": "is_willing_travel",
      "error": _vm.errors.is_willing_travel,
      "error-text": _vm.errors.is_willing_travel
    },
    model: {
      value: (_vm.user.is_willing_travel),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_willing_travel", $$v)
      },
      expression: "user.is_willing_travel"
    }
  }, [_vm._v("Готовность к командировкам")])], 1), _c('div', {
    staticClass: "dedicatedBlock dedicatedBlockSecond form form_grid form_top"
  }, [_c('Select', {
    staticClass: "column",
    attrs: {
      "label": "Форма занятости",
      "name": "employment_id",
      "placeholder": "Выберите форму занятости",
      "multiple": false,
      "filterable": false,
      "error": _vm.errors.employment_id,
      "error-text": _vm.errors.employment_id,
      "options": _vm.employmentDictionary
    },
    model: {
      value: (_vm.user.employment_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "employment_id", $$v)
      },
      expression: "user.employment_id"
    }
  }), _c('FormInput', {
    staticClass: "column",
    attrs: {
      "label": "Зарплата, руб. (на руки)",
      "name": "salary",
      "placeholder": "Введите зарплату",
      "error": _vm.errors.salary,
      "error-text": _vm.errors.salary,
      "type": "number"
    },
    model: {
      value: (_vm.user.salary),
      callback: function($$v) {
        _vm.$set(_vm.user, "salary", $$v)
      },
      expression: "user.salary"
    }
  }), _c('Checkbox', {
    staticClass: "column",
    attrs: {
      "name": "is_willing_relocate",
      "error": _vm.errors.is_willing_relocate,
      "error-text": _vm.errors.is_willing_relocate
    },
    model: {
      value: (_vm.user.is_willing_relocate),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_willing_relocate", $$v)
      },
      expression: "user.is_willing_relocate"
    }
  }, [_vm._v("Готовность к переезду")]), _c('Checkbox', {
    staticClass: "column",
    attrs: {
      "name": "is_housing_needed",
      "error": _vm.errors.is_housing_needed,
      "error-text": _vm.errors.is_housing_needed
    },
    model: {
      value: (_vm.user.is_housing_needed),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_housing_needed", $$v)
      },
      expression: "user.is_housing_needed"
    }
  }, [_vm._v("Необходимо жилье")])], 1)]), _c('div', {
    staticClass: "saveblock"
  }, [_c('Message', {
    attrs: {
      "accent": _vm.correctUpdateProfile,
      "bottom": true,
      "color": _vm.color
    }
  }, [_vm._v(_vm._s(_vm.text))]), _c('Button', {
    attrs: {
      "disabled": !_vm.changed,
      "isLoading": _vm.isLoading
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("Сохранить изменения")])], 1), _c('Button', {
    attrs: {
      "alignSelf": "end",
      "bordered": true
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Отменить изменения")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736ee85d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/interests/InterestsSettings.vue
// module id = ec3cdc1ba475038f6950
// module chunks = 55